import { Component, inject } from '@angular/core';
import { CTSyncMapGridService } from '../ct-map/services/ct-sync-map-grid.service';

const COMPONENT_SELECTOR = 'ct-grid-map-selection-sync';
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './grid-map-selection-sync.component.html',
  styleUrl: './grid-map-selection-sync.component.scss',
  standalone: false,
})
export class GridMapSelectionSyncComponent {
  isLocked = true;
  private _ctSyncMapGridService = inject(CTSyncMapGridService);

  toggleLock() {
    this.isLocked = !this.isLocked;
    this._ctSyncMapGridService.setSyncGridMap(!this.isLocked);
  }
}
